import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DepartmentSheetEdit } from "@app/modules/supplier-portal/components/departmentSheet-edit/departmentSheet-edit.component";
import { SupplierPortalPage } from "@app/modules/supplier-portal/containers/supplier-portal-page/supplier-portal-page.component";

const routes: Routes = [
    { path: '', component: SupplierPortalPage },
    { path: 'new', component: DepartmentSheetEdit },
    { path: 'edit/:id', component: DepartmentSheetEdit }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class SupplierPortalRoutingModule {}